import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-start text-start",
  tabindex: "-1",
  id: "offcanvasNavbar",
  "aria-labelledby": "offcanvasNavbarLabel"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2 ms-auto" }
const _hoisted_4 = { class: "d-md-none" }
const _hoisted_5 = { class: "offcanvas-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brand_logo = _resolveComponent("brand-logo")!
  const _component_data_bs_theme = _resolveComponent("data-bs-theme")!
  const _component_language_switcher = _resolveComponent("language-switcher")!
  const _component_login_button = _resolveComponent("login-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createVNode(_component_brand_logo, {
          to: "/",
          "img-style": "height: 36px"
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_data_bs_theme, {
              onChangeTheme: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeTheme', $event)))
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "offcanvas"
          }, null, -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "nav-panel"),
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        _createVNode(_component_language_switcher, { class: "mt-3 mt-md-0 me-0 me-md-3" }),
        _createVNode(_component_login_button)
      ])
    ])
  ]))
}